
import { Product } from "@/types/product";
import { ircBT1 } from "./irc-bt1";
import { btAC1 } from "./bt-ac1";
import { ipaSFP1G20 } from "./ipa-sfp-1g20";
import { ipaSFPRJ451 } from "./ipa-sfp-rj45-1";

export const vpxAccessories: Product[] = [
  ircBT1,
  btAC1,
  ipaSFP1G20,
  ipaSFPRJ451
];
